exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-0cb6f08a]{max-height:200px}@media (max-width:575px){.btn[data-v-0cb6f08a]{display:block;width:100%}}", ""]);

// exports
